import React from 'react'
import Layout from 'components/shared/Layout'
import classnames from 'classnames/bind'
import css from './styles.module.scss'
import FeatureCard from 'src/components/shared/FeatureCard'

const cx = classnames.bind(css)

const CapabilitiesCards = ({ capabilityCards }) => {
  return (
    <Layout type="wrapper" className={css.layout}>
      <div className={css.wrapper}>
          {capabilityCards.map((card, index) => (
            <FeatureCard {...card} index={index} key={index} isHomePage />
          ))}
      </div>
    </Layout>
  )
}

export default CapabilitiesCards
